/** 附件业务类型API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/base/bizAttachmentType';
/**
 * 分页查询附件业务类型
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.BizAttachmentType> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询附件业务类型列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.BizAttachmentType> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个附件业务类型
 *
 * @param id 附件业务类型ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.BizAttachmentType> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存附件业务类型
 *
 * @param params 附件业务类型信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新附件业务类型信息
 *
 * @param params 附件业务类型信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除附件业务类型
 *
 * @param id 附件业务类型ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除附件业务类型
 *
 * @param ids 附件业务类型ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
